// Le consultant de l'ABS (CDC du 14/10/2026, § 7.2) : `users.role = 'analyst'`, « consultant » partout
// dans l'interface. Il n'obtient que ses études : ni observatoire, ni administration, ni ventes, ni
// comptes. Le serveur l'impose (404 sur tout le reste) ; le navigateur le ramène à ses études au lieu
// de lui montrer des pages qu'il ne peut pas lire.
export const ROLE_CONSULTANT = 'analyst'

/** Ce qu'un consultant peut ouvrir : ses études, les pages de connexion et les pages légales. */
const PAGES_DU_CONSULTANT = [
  /^\/etudes(\/|$)/,
  /^\/(login|forgot-password|reset-password)\/?$/,
  /^\/(mentions-legales|confidentialite|cgv|accessibilite)\/?$/,
]

export function pagePermiseAuConsultant(chemin: string): boolean {
  return PAGES_DU_CONSULTANT.some(m => m.test(chemin))
}
